export default "__VITE_ASSET__Cu4eAav0__"